// extracted by mini-css-extract-plugin
export default {"button":"CartButton_button__D7Okm","cartlogo":"CartButton_cartlogo__IUPjq","badge":"CartButton_badge__zmCh1"};